import {
  isString
} from 'lodash';

/**
 * 平台判断常量
 * @namespace
 * @type {{__detect: detect, browser: {}, os: {}, isWeChat}}
 *
 * @example
 *
 * // chrome浏览器当中
 * {
 *   "browser": {
 *     "webkit": true,
 *     "version": "62.0.3202.94",
 *     "chrome": true
 *  },
 *  "os": {
 *     "tablet": false,
 *     "phone": false
 *   }
 * }
 *
 * // in iphone 6
 * {
 *  "browser": {
 *    "webkit": true,
 *    "version": "601.1.46"
 *  },
 *  "os": {
 *    "iphone": true,
 *    "ios": true,
 *    "version": "9.1",
 *    "tablet": false,
 *    "phone": true
 *  }
 * }
 *
 * // in android galaxy 5
 * {
 *   "browser": {
 *     "webkit": true,
 *     "version": "62.0.3202.94",
 *     "chrome": true
 *   },
 *   "os": {
 *     "android": true,
 *     "version": "5.0",
 *     "tablet": false,
 *     "phone": true
 *   }
 * }
 *
 */
const platform = {
  __detect: detect,
  /**
   * 当前浏览器信息
   */
  browser: {},
  /**
   * 当前操作系统信息
   */
  os: {},
  /**
   * 检测是否为微信
   * @function isWeChat
   * @memberOf platform
   * @static
   * @return {boolean}
   *
   * @example
   * // 检测是否在微信平台
   * platform.isWeChat(); // return true or false
   *
   */
  isWeChat: (function () {
    var result = (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger");
    return function () {
      return result;
    }
  })(),
  /**
   * 检测是否在App及平台
   *
   * @function isApp
   * @memberOf platform
   * @param {string} [plat] 平台信息
   * @return {boolean}
   *
   *
   * @example
   * // 检测是否在APP当中
   * platform.isApp(); // return true or false
   *
   * @example
   * // 判断当前是否在android app当中
   * platform.isApp('android'); return true or false
   *
   * @example
   * // 是测是否在ios系统当中
   * platform.isApp('ios'); return true or false
   *
   * @example
   * // 判断是否安装在iphone手机当中
   * platform.isApp('iphone'); return true or false
   *
   */
  isApp: (function () {
    let protocol = location.protocol;
    let isInApp = protocol.toLowerCase() === 'file:' &&
      typeof cordova === 'object'/* && 'InAppBrowser' in cordova &&
      typeof cordova.removeWindowEventHandler === "function"*/;
    return function (plat) {
      if (isString(plat)) {
        return platform.os[plat] && isInApp;
      }
      return isInApp;
    }
  })()
};

/**
 * 处理浏览器平台化参数
 * @ignore
 */
function detect(ua) {
  var os = this.os = {}, browser = this.browser = {},
    webkit = ua.match(/WebKit\/([\d.]+)/),
    android = ua.match(/(Android)\s+([\d.]+)/),
    ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/),
    touchpad = webos && ua.match(/TouchPad/),
    kindle = ua.match(/Kindle\/([\d.]+)/),
    silk = ua.match(/Silk\/([\d._]+)/),
    blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/),
    bb10 = ua.match(/(BB10).*Version\/([\d.]+)/),
    rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/),
    playbook = ua.match(/PlayBook/),
    chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/),
    firefox = ua.match(/Firefox\/([\d.]+)/)

  // Todo: clean this up with a better OS/browser seperation:
  // - discern (more) between multiple browsers on android
  // - decide if kindle fire in silk mode is android or not
  // - Firefox on Android doesn't specify the Android version
  // - possibly devide in os, device and browser hashes

  if (browser.webkit = !!webkit) browser.version = webkit[1]

  if (android) os.android = true, os.version = android[2]
  if (iphone) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.')
  if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.')
  if (webos) os.webos = true, os.version = webos[2]
  if (touchpad) os.touchpad = true
  if (blackberry) os.blackberry = true, os.version = blackberry[2]
  if (bb10) os.bb10 = true, os.version = bb10[2]
  if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2]
  if (playbook) browser.playbook = true
  if (kindle) os.kindle = true, os.version = kindle[1]
  if (silk) browser.silk = true, browser.version = silk[1]
  if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true
  if (chrome) browser.chrome = true, browser.version = chrome[1]
  if (firefox) browser.firefox = true, browser.version = firefox[1]

  os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) || (firefox && ua.match(/Tablet/)))
  os.phone = !!(!os.tablet && (android || iphone || webos || blackberry || bb10 || (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) || (firefox && ua.match(/Mobile/))))
}

detect.call(platform, navigator.userAgent);

export default platform;


// WEBPACK FOOTER //
// ./src/class/Platform.js